import { API, Auth } from 'aws-amplify'
import React, { useState } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { Table } from '@aws-amplify/ui-react';
import QueryRow from './QueryRow';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { Search } from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';
import QuerySearchesLegal from '../../data/query_searches_legal'
import QuerySearchesLegalDetail from '../../data/query_searches_legal_detail'

const QueryTable = (props) => {
  const [input, setInput] = useState("")
  const [entities, setEntities] = useState(null)
  const [text, setText] = useState("")
  const [keyword, setKeyword] = useState("")
  const [label1, setLabel1] = useState("")
  const [label2, setLabel2] = useState("")
  const [isBusy, setIsBusy] = useState(false);
  const [notFoundText, setNotFound] = useState('');
  const [topanswer, setTopanswer] = useState(null)
  const [pageno, setPageno] = useState("");
  const projectId = props.project_id;

  const search = async (e) => {
    setIsBusy(true);
    await sleep(2000);
    setIsBusy(false);
    setNotFound('');
    setKeyword(e.input);
    setTopanswer(null)
    setEntities([])
    setLabel1("")
    setLabel2("")
    setEntities(QuerySearchesLegal.items.items.other_answers)
    // const user = await Auth.currentAuthenticatedUser();
    // const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
  //   API.get("DocumentSearchUser", `/querysearch?projectid=${projectId}&keyword=${e.input}`, requestInfo)
  //     .then(response => {
  //       setIsBusy(false);
  //       console.log('response');

  //         console.log(response);
  //         setEntities(response.items.items.other_answers)
  //         setTopanswer(response.items.items.top_answer)
  //         props.onSearch(response.report_id)
  //         if(response.items.items.other_answers.length == 0 && response.items.items.top_answer == undefined)
  //           {
  //             setNotFound('No results found!');
  //           }
  //         if(response.items.items.top_answer == undefined)
  //         {
  //           setLabel1("")
  //         }
  //         else
  //         {
  //           setLabel1("Best Answer")
  //         }
  //         if(response.items.items.other_answers == undefined || response.items.items.other_answers.length == 0)
  //         {
  //           setLabel2("")
  //         }
  //         else
  //         {
  //           setLabel2("Other Answer")
  //         }


  //       })
  //   .catch(error => {
  //     setIsBusy(false);
  //   console.log(error);
  // })
  };
  const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
  const handleDetail = async (entity) => {
    console.log(entity);
    let response = QuerySearchesLegalDetail.filter(item => item.page_no === entity.page[0])
    // let response = QuerySearchesLegalDetail.filter(item => {console.log(item.page_no=== entity.page[0])})
    console.log(response)
    setPageno('')
    setIsBusy(true);
        await sleep(2000);
    setIsBusy(false);
    setText(response[0].text);
    setPageno(`Page ${response[0].page_no} of ${response[0].no_pages}`)
  };
  
  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/projects" }}>Projects</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/files?projectid=" + projectId }}>{projectId}</Breadcrumb.Item>
            <Breadcrumb.Item active>Query</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1>Query Search</h1>
        </Col>
      </Row>
      <Row>
        <Col sm="5">
          <InputGroup className="mb-3">
            <FormControl
              placeholder="What is legal aid?"
              aria-label="enter search phrase"
              aria-describedby="basic-addon2"
              value={input} onChange={(e) => setInput('What is legal aid?')}
            />
            <Button variant="outline-secondary" id="button-addon2" onClick={() => search({ input })}>
              <Search />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <div key={entities?.user_id} className="float-child">
            <div style={{ "height": "50vh", "overflow-x": "hidden", "overflow-y": "auto" }}>
            <h5 style={{ color: 'red' }}>{notFoundText}</h5>
                  <h3>{label1}</h3>
              <Table>
                <tbody>
                  { (topanswer != null &&
                    <QueryRow key="top_answer" entity={topanswer} projectId={projectId} OnDetail={handleDetail} />
                  )}
                  </tbody>
                </Table>
                  <h3>{label2}</h3>
              <Table>
                <tbody>
                  {
                    entities != null &&

                    entities?.map((thisEntity, index) => {
                      return (
                        <QueryRow key={index} entity={thisEntity} projectId={projectId} OnDetail={handleDetail} />
                      )
                    })
                  }
                </tbody>
              </Table>
            </div>
          </div>
          <div className="float-child">
            <div id='doctextarea' style={{ "width": "100%", "height": "50vh", "padding": "20px", "overflow-y": "auto" }} readOnly dangerouslySetInnerHTML={{ __html: text }}></div>
            <div style={{ textAlign: 'right' }}>
              {pageno}
            </div>
          </div>
          
        </Col>
      </Row>
    </>
  )
}
export default QueryTable;